// Types of entities that are folder containers, i.e., have visible children. Note that all entities can have children,

import { isFolder } from './core/index.js'
import { isBandSpace } from './extensions/index.js'

// so this is just for the UI to show a different view.
export const isFolderContainer = (entity: unknown) => isFolder(entity) || isBandSpace(entity)
